<div class="container">
  <form [formGroup]="form" class="form">
    <app-form-row [label]="'Accounts'">
      <ng-select 
        [items]="dropdownData.accounts"
        [bindLabel]="'username'"
        [bindValue]="'id'"
        [formControl]="form.get('account')"
        [clearable]="false"
        (change)="onAccountChange($event)">
      </ng-select>
    </app-form-row>
  </form>
</div>
